import { render, staticRenderFns } from "./RincianSaldo.vue?vue&type=template&id=f9728118"
import script from "./RincianSaldo.vue?vue&type=script&lang=js"
export * from "./RincianSaldo.vue?vue&type=script&lang=js"
import style0 from "./RincianSaldo.vue?vue&type=style&index=0&id=f9728118&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports